import type { ModuleId } from '../../core/store';
import { akor } from './akor';
import type { Lesson } from './blocks';
import { gitar } from './gitar';
import { nota } from './nota';
import { vokal } from './vokal';

export type { Block, Lesson } from './blocks';

/** All lessons, by module, in display order. */
export const LESSONS: Record<ModuleId, Lesson[]> = { gitar, nota, vokal, akor };

export const lessonsOf = (module: string): Lesson[] => LESSONS[module as ModuleId] ?? [];
